import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "background.paper",
        padding: 2,
        boxShadow: 3,
        zIndex: 9999,
        textAlign: "center",
      }}
    >
      <Typography variant="body1" color="text.secondary">
        Diese Website verwendet Cookies, um Ihnen ein optimales Erlebnis zu bieten. 
        Sie können Ihre Präferenzen jederzeit ändern.
      </Typography>
      <Box sx={{ marginTop: 1 }}>
        <Button variant="contained" color="primary" onClick={handleAccept} sx={{ marginRight: 1 }}>
          Akzeptieren
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleDecline}>
          Ablehnen
        </Button>
      </Box>
    </Box>
  );
};

export default CookieBanner;
